import React from "react";
import moment from "moment";

interface ValidPackageRangeProps {
  packageName: string;
  fromPrice?: number;
  validToTravelFrom: Date;
  validToTravelEnd: Date;
  fontColor: string;
}

const ValidPackageRange = ({
  packageName,
  fromPrice,
  validToTravelFrom,
  validToTravelEnd,
  fontColor
}: ValidPackageRangeProps) => {
  const validFrom = moment(validToTravelFrom).format("MMM Do, YYYY");
  const validTo = moment(validToTravelEnd).format("MMM Do, YYYY");
  let datesValid = true;
  if (validFrom === 'Invalid date' || validTo === 'Invalid date') { 
    datesValid = false;
  }

  return (
    <div className="text-center">
      <h6 className="font-weight-bold mb-0" style={{ color: fontColor }}>
        {packageName} - From ${fromPrice}
      </h6>
      {datesValid && (
        <p className="itinerary-info mr-2 mb-2" style={{ marginTop: "-4px" }}>
          <span>
            <i className="far fa-calendar-alt"></i>
          </span> Valid {validFrom} - {validTo}
        </p>
      )}
      {!datesValid && (
        <p className="itinerary-info mr-2 mb-2" style={{ marginTop: "-4px" }}>
          <span>
            <i className="far fa-calendar-alt"></i>
          </span> Valid Anytime
        </p>
      )}
    </div>
  )
};

export default ValidPackageRange;
